import { POI_TYPES } from '../constants/poiTypes';
import { logError, logInfo } from './logger';
import { Navigation2, MapPin } from 'lucide-react';

export const generatePOIId = (type, routeNumber, sequence) => {
  const prefix = POI_TYPES[type]?.prefix || 'XX';
  const route = String(routeNumber).padStart(2, '0');
  const seq = String(sequence).padStart(4, '0');
  return `${prefix}-${route}-${seq}`;
};

export const getPOIIcon = (type) => {
  if (!type || !POI_TYPES[type]) {
    return MapPin;
  }
  return POI_TYPES[type].icon || MapPin;
};

export const getElevation = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://api.open-elevation.com/api/v1/lookup?locations=${latitude},${longitude}`
    );
    if (!response.ok) throw new Error('Failed to fetch elevation');
    const data = await response.json();
    return data.results?.[0]?.elevation;
  } catch (error) {
    logError('Failed to get elevation:', error);
    return null;
  }
};